export var CARTRIDGE_TYPE;
(function (CARTRIDGE_TYPE) {
    CARTRIDGE_TYPE["ARROW"] = "ARROW";
    CARTRIDGE_TYPE["FIREBALL"] = "FIREBALL";
})(CARTRIDGE_TYPE || (CARTRIDGE_TYPE = {}));
